import { render, staticRenderFns } from "./UploadXmlModal.vue?vue&type=template&id=5a795184"
import script from "./UploadXmlModal.vue?vue&type=script&lang=js"
export * from "./UploadXmlModal.vue?vue&type=script&lang=js"
import style0 from "./UploadXmlModal.vue?vue&type=style&index=0&id=5a795184&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports